import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { MaterialItemsModule } from './material-items.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AbbreviatePipe } from './pipes/abbreviate.pipe';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// Remove this after giant machines is merged
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import { MAT_DRAWER_DEFAULT_AUTOSIZE } from '@angular/material/sidenav';
import { SnackbarComponent } from './components/custom-snack-bar/custom-snackbar.component';
import { LinebreakPipe } from './pipes/linebreak.pipe';
import {
  ButtonDirective,
  SegmentedButtonsDirective,
  SegmentedButtonsIconDirective,
  WcgButtonComponent,
  WcgComboboxComponent,
  WcgCustomPipesModule,
  WcgDialogModule,
  WcgPopoverModule,
} from '@wcg/frontend-framework';
import { MatFormFieldModule } from '@angular/material/form-field';

import { IrbCategoriesComponent } from './components/irb-categories/irb-categories.component';
import { SearchFilterPipe } from './pipes/search.pipe';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { FileUploadStatusComponent } from '../documents/file-upload-status/file-upload-status.component';
import { ChipStatusModule } from './components/chip-status/chip-status.module';
import {
  CreateGridViewComponent,
  GridViewDropDownComponent,
} from '@shared/components/grid-views';
import { GridViewFacadeService } from '@data-access/grid-views';
import { TableActionsModule } from './components/wcg-table/table-actions/table-actions.module';

@NgModule({
  providers: [
    Overlay,
    TitleCasePipe,
    { provide: MAT_DRAWER_DEFAULT_AUTOSIZE, useValue: { autosize: true } },
    GridViewFacadeService,
  ],
  declarations: [
    IrbCategoriesComponent,
    LinebreakPipe,
    SearchFilterPipe,
    SnackbarComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    OverlayModule,
    MaterialItemsModule,
    ScrollingModule,
    MatGridListModule,
    MatTableModule,
    RouterModule.forChild([]),
    MatSlideToggleModule,
    WcgDialogModule,
    MatIconModule,
    WcgComboboxComponent,
    WcgButtonComponent,
    ButtonDirective,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    SegmentedButtonsDirective,
    SegmentedButtonsIconDirective,
    WcgCustomPipesModule,
    FileUploadStatusComponent,
    ChipStatusModule,
    WcgPopoverModule,
    CreateGridViewComponent,
    GridViewDropDownComponent,
    TableActionsModule,
    AbbreviatePipe,
    PhoneFormatPipe,
  ],
  exports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    OverlayModule,
    MatGridListModule,
    MatTableModule,
    MatSlideToggleModule,
    LinebreakPipe,
    PhoneFormatPipe,
    ButtonDirective,
    IrbCategoriesComponent,
    SearchFilterPipe,
    WcgCustomPipesModule,
    ChipStatusModule,
    AbbreviatePipe,
    TableActionsModule,
  ],
})
export class SharedModule {}
